import { X, Check, Moon, Clock, FileX, AlertCircle, Sun, Timer, FileCheck, Target } from "lucide-react";

const BeforeAfterSection = () => {
  const beforeItems = [
    { icon: Moon, text: "Notes completed after hours" },
    { icon: FileX, text: "Manual corrections needed" },
    { icon: AlertCircle, text: "Inconsistent records" },
  ];

  const afterItems = [
    { icon: Timer, text: "Clean notes on time" },
    { icon: FileCheck, text: "Accurate and standardized" },
    { icon: Target, text: "Focus on care, not typing" },
  ];

  return (
    <section 
      data-testid="before-after-section"
      className="py-16 sm:py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-xs sm:text-sm font-medium uppercase tracking-widest text-cyan-500 mb-3 sm:mb-4 block">
            The Transformation
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white">
            Before vs With MedinoteX
          </h2>
        </div>

        {/* Comparison Grid */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-12">
          {/* Before Card */}
          <div className="glass-card p-6 sm:p-8 md:p-10 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-500/50 to-transparent" />
            <div className="flex items-center gap-3 mb-6 sm:mb-8">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-red-500/10 border border-red-500/20 flex items-center justify-center">
                <X className="w-5 h-5 sm:w-6 sm:h-6 text-red-500" />
              </div>
              <h3 className="text-xl sm:text-2xl font-semibold text-white">Before MedinoteX</h3>
            </div>
            <ul className="space-y-4 sm:space-y-5">
              {beforeItems.map((item, index) => (
                <li 
                  key={index}
                  className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 rounded-xl bg-red-500/5 border border-red-500/10"
                >
                  <item.icon className="w-4 h-4 sm:w-5 sm:h-5 text-red-400 flex-shrink-0" />
                  <span className="text-slate-300 text-sm sm:text-base">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* After Card */}
          <div className="glass-card p-6 sm:p-8 md:p-10 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-500 to-transparent" />
            <div className="flex items-center gap-3 mb-6 sm:mb-8">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center">
                <Check className="w-5 h-5 sm:w-6 sm:h-6 text-cyan-500" />
              </div>
              <h3 className="text-xl sm:text-2xl font-semibold text-white">With MedinoteX</h3>
            </div>
            <ul className="space-y-4 sm:space-y-5">
              {afterItems.map((item, index) => (
                <li 
                  key={index}
                  className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 rounded-xl bg-cyan-500/5 border border-cyan-500/10"
                >
                  <item.icon className="w-4 h-4 sm:w-5 sm:h-5 text-cyan-400 flex-shrink-0" />
                  <span className="text-slate-300 text-sm sm:text-base">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
